<!-- CustomDescription is handled with FeatureFlag improved-feature-handling from WhitelabelVehicleController -->
<template>
    <div>
        <h3 class="mb-4">{{$t('pds.more.informations')}}</h3>
        <div :style="contentStyle" class="limited-height">
            <div ref="content" v-html="formattedContent"></div>
        </div>
        <div class="toggle-text" @click="toggleContent">
            <span v-if="!isExpanded">{{$t('pds.complete_equipment.show_more')}} <font-awesome-icon icon="fas fa-chevron-down" /></span>
            <span v-else>{{$t('pds.complete_equipment.show_less')}} <font-awesome-icon icon="fas fa-chevron-up" /></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomDescription',
        data() {
            return {
            isExpanded: false,
            maxHeight: 500,
            contentHeight: 0,
            };
        },
        props: {
            entry: {
                type: Object,
                required: true
            }
        },
        computed: {
            formattedContent() {
                return this.entry.custom_description.replace(/\n/g, '<br>')
            },
            contentStyle() {
                return {
                    overflow: this.isExpanded ? 'visible' : 'hidden',
                    maxHeight: this.isExpanded ? 'none' : `${this.maxHeight}px`,
                };
            },
            shouldShowMoreButton() {
                return this.contentHeight > this.maxHeight;
            },
        },
        methods: {
            toggleContent() {
                this.isExpanded = !this.isExpanded;
            },
            updateContentHeight() {
                this.$nextTick(() => {
                    this.contentHeight = this.$refs.content.clientHeight;
                });
            },
        },
        mounted() {
            this.updateContentHeight();
            window.addEventListener('resize', this.updateContentHeight);
        },
    }
</script>

<style scoped>
    .limited-height {
        margin-bottom: 1em;
    }
</style>